import {FC, useCallback, useRef} from 'react'
import {SubClient} from '../../../../../services/cellcast.v2.types'
import NodataYet from '../../../../Components/NodataYet'
import SenderDedicatedNumber, {SenderDedicatedNumberRef} from './SenderDedicatedNumber'
import SenderBusinessNumber, {SenderBusinessNumberRef} from './SenderBusinessNumber'
import SenderCustomNumber, {SenderCustomNumberRef} from './SenderCustomNumber'

export type SenderWrapperProps = {
  data: SubClient | undefined
}

const SenderWrapper: FC<SenderWrapperProps> = (props) => {
  const {data} = props

  // Refs to access refresh functions from child components
  const dedicatedNumberRef = useRef<SenderDedicatedNumberRef>(null)
  const businessNumberRef = useRef<SenderBusinessNumberRef>(null)
  const customNumberRef = useRef<SenderCustomNumberRef>(null)

  // Shared refresh function that refreshes all three tables
  const refreshAllTables = useCallback(() => {
    dedicatedNumberRef.current?.refreshData()
    businessNumberRef.current?.refreshData()
    customNumberRef.current?.refreshData()
  }, [])

  return (
    <>
      {data ? (
        <>
          <SenderDedicatedNumber
            data={data}
            ref={dedicatedNumberRef}
            onDefaultChange={refreshAllTables}
          />
          <SenderBusinessNumber
            data={data}
            ref={businessNumberRef}
            onDefaultChange={refreshAllTables}
          />
          <SenderCustomNumber
            data={data}
            ref={customNumberRef}
            onDefaultChange={refreshAllTables}
          />
        </>
      ) : (
        <NodataYet />
      )}
    </>
  )
}

export default SenderWrapper
